var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column has-text-centered"},[_c('p',{staticClass:"is-size-1"},[_vm._v("404")]),_c('p',{staticClass:"has-text-grey"},[_vm._v("Не найдено")])])])])])
}]

export { render, staticRenderFns }